import { useEffect } from "react";
import type { QueryClient } from "@tanstack/react-query";
import { processPendingPushRead, registerForPushNotifications } from "@/utils/push-notifications";

interface PushBootstrapOptions {
  isAuthenticated: boolean;
  isLoading: boolean;
  notificationsEnabled: boolean;
  queryClient: QueryClient;
}

export function usePushBootstrap({
  isAuthenticated,
  isLoading,
  notificationsEnabled,
  queryClient,
}: PushBootstrapOptions) {
  useEffect(() => {
    if (!isAuthenticated || !notificationsEnabled) return;

    registerForPushNotifications().catch(error => {
      console.warn("Push registration skipped:", error);
    });
  }, [isAuthenticated, notificationsEnabled]);

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    processPendingPushRead().then(() => {
      queryClient.invalidateQueries({ queryKey: ["notifications-inbox"] });
    });
  }, [isLoading, isAuthenticated, queryClient]);
}
